//
//
//
//
//
//

export default {
  props: {
    sitekey: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: false,
      default: () => 'Send',
    },
    isDetailv2: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      widgetId: null,
    }
  },
  mounted() {
    this.$smartCaptchaReady.then((smartCaptcha) => {
      this.widgetId = smartCaptcha.render(this.$refs.container, {
        sitekey: this.sitekey,
        invisible: true,
        callback: this.onCaptchaPassed,
        hideShield: true,
      })
    })
  },
  methods: {
    execute() {
      if (this.widgetId != null) {
        this.$smartCaptchaReady.then((smartCaptcha) => {
          smartCaptcha.execute(this.widgetId)
        })
      }
    },
    onCaptchaPassed(token) {
      this.$emit('verified', token)
    },
  },
}
